export const openCenteredBrowserWindow = (
    url: string,
    title?: string,
    features?: string
) => {
    const width = screen.width / 1.5
    const height = screen.height / 1.2
    const left = (window.screen.width - width) / 1.7
    const top = (window.screen.height - height) / 2

    // open a new window
    const newWindow = window.open(
        url,
        title,
        `width=${width},height=${height},left=${left},top=${top},${features}`
    )
    newWindow?.focus()
}
